import { Outlet, createFileRoute, useLocation, useNavigate } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';
import { SimpleYearMonthPicker } from '@/components/DatePicker/SimpleYearMonthPicker';
import FillScreen from '@/components/Layout/FillScreen';
import { ContractAndCostToolbar, type ContractAndCostSection } from '@/features/contract-and-cost/contract-and-cont-toolbar/ContractAndCostToolbar';
import { formatPeriod, getDefaultPeriod, parsePeriodStart } from '@/features/contract-and-cost/period';
export const Route = createFileRoute('/_staff/software/_layout/contract-and-cost/_contract-and-cost')({
  component: ContractAndCostLayout
});
const PERIOD_PATH_REGEX = /\/contract-and-cost\/(payment|cost)\/(\d{6}_\d{6})/;
function ContractAndCostLayout() {
  return <ContractAndCostContent />;
}
function ContractAndCostContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const section: ContractAndCostSection = (() => {
    const path = location.pathname;
    if (path.includes('/contract-and-cost/payment')) return 'payment';
    if (path.includes('/contract-and-cost/cost')) return 'cost';
    return 'deal';
  })();
  const periodMatch = location.pathname.match(PERIOD_PATH_REGEX);
  const rawPeriod = periodMatch?.[2];
  const periodStart = useMemo(() => rawPeriod ? parsePeriodStart(rawPeriod) : undefined, [rawPeriod]);
  const handleSectionChange = useCallback((newSection: ContractAndCostSection) => {
    if (newSection === 'payment' || newSection === 'cost') {
      const period = rawPeriod ?? getDefaultPeriod();
      navigate({
        to: `/software/contract-and-cost/${newSection}/${period}`
      });
    } else {
      navigate({
        to: `/software/contract-and-cost/${newSection}`
      });
    }
  }, [navigate, rawPeriod]);
  const handlePeriodChange = useCallback((value: {
    year: number;
    month: number;
  } | undefined) => {
    if (value) {
      const newPeriod = formatPeriod(value.year, value.month);
      navigate({
        to: `/software/contract-and-cost/${section}/${newPeriod}`
      });
    }
  }, [navigate, section]);
  const showPeriodPicker = section === 'payment' || section === 'cost';
  return <FillScreen className="flex flex-col">
      <ContractAndCostToolbar value={section} onValueChange={handleSectionChange} rightContent={showPeriodPicker ? <SimpleYearMonthPicker value={periodStart} onChange={handlePeriodChange} className="w-32 bg-white" /> : undefined} />
      <Outlet />
    </FillScreen>;
}